import React from 'react';

// NOTE: v1 placeholder artwork from the seasonal_accessories_final.html
// mock. Composition + visibility tier are correct; linework should be
// replaced with polished designer SVGs before any significant push.
//
// Renders inside Turbo's existing 200x200 viewBox.
export default function WinterAccessory() {
  return (
    <g aria-hidden="true">
      {/* Bobble hat — dome body with white cuff and pompom on top */}
      <path d="M68,96 Q68,60 100,55 Q132,60 132,96 Z" fill="#2E8FA1" />
      <path d="M75,75 Q100,68 125,75" stroke="#1f5e6b" strokeWidth="2" fill="none" opacity="0.6" />
      <path d="M72,85 Q100,80 128,85" stroke="#1f5e6b" strokeWidth="2" fill="none" opacity="0.6" />
      {/* White cuff/band at bottom */}
      <path d="M64,93 Q64,100 68,103 L132,103 Q136,100 136,93 Q136,88 132,88 L68,88 Q64,88 64,93 Z" fill="#F9FCF1" />
      {/* Pompom at the very top */}
      <circle cx="100" cy="48" r="9" fill="#F9FCF1" />
      <circle cx="96" cy="45" r="3" fill="#dde0d5" />
      <circle cx="103" cy="46" r="2.5" fill="#dde0d5" />
      <circle cx="100" cy="51" r="2.5" fill="#dde0d5" />
      {/* Snowflakes scattered around */}
      <g stroke="#F9FCF1" strokeWidth="1.5" strokeLinecap="round" fill="none">
        <g transform="translate(28 70)">
          <line x1="0" y1="-9" x2="0" y2="9" />
          <line x1="-9" y1="0" x2="9" y2="0" />
          <line x1="-6" y1="-6" x2="6" y2="6" />
          <line x1="-6" y1="6" x2="6" y2="-6" />
          <line x1="-2" y1="-9" x2="2" y2="-9" />
          <line x1="-2" y1="9" x2="2" y2="9" />
          <line x1="-9" y1="-2" x2="-9" y2="2" />
          <line x1="9" y1="-2" x2="9" y2="2" />
        </g>
        <g transform="translate(172 75)">
          <line x1="0" y1="-7" x2="0" y2="7" />
          <line x1="-7" y1="0" x2="7" y2="0" />
          <line x1="-5" y1="-5" x2="5" y2="5" />
          <line x1="-5" y1="5" x2="5" y2="-5" />
        </g>
        <g transform="translate(20 115)">
          <line x1="0" y1="-7" x2="0" y2="7" />
          <line x1="-7" y1="0" x2="7" y2="0" />
          <line x1="-5" y1="-5" x2="5" y2="5" />
          <line x1="-5" y1="5" x2="5" y2="-5" />
        </g>
        <g transform="translate(180 115)">
          <line x1="0" y1="-6" x2="0" y2="6" />
          <line x1="-6" y1="0" x2="6" y2="0" />
          <line x1="-4" y1="-4" x2="4" y2="4" />
          <line x1="-4" y1="4" x2="4" y2="-4" />
        </g>
        <g transform="translate(55 40)">
          <line x1="0" y1="-5" x2="0" y2="5" />
          <line x1="-5" y1="0" x2="5" y2="0" />
          <line x1="-3.5" y1="-3.5" x2="3.5" y2="3.5" />
          <line x1="-3.5" y1="3.5" x2="3.5" y2="-3.5" />
        </g>
        <g transform="translate(150 40)">
          <line x1="0" y1="-5" x2="0" y2="5" />
          <line x1="-5" y1="0" x2="5" y2="0" />
          <line x1="-3.5" y1="-3.5" x2="3.5" y2="3.5" />
          <line x1="-3.5" y1="3.5" x2="3.5" y2="-3.5" />
        </g>
      </g>
    </g>
  );
}
